export function sortAttachedFilesByDate(arr) {
  return arr.sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  )
}
